<template lang="pug">
  .dashboard-container
    b-container
      .header
        .header-body
          h6.header-pretitle
            | My first section
          h1.header-title
            | Typography

      .block
        .gallery
          .gallery-element
          .gallery-element
          .gallery-element
          .gallery-element
      b-alert(show, variant="success") Bienvenido al nuevo Dashboard.
      b-card
        b-form
          b-form-group#input-group-1(label='Email address:', label-for='input-1', description="We'll never share your email with anyone else.")
            b-form-input#input-1(v-model='form.email', type='email', required='', placeholder='Enter email')
          b-form-group#input-group-2(label='Your Name:', label-for='input-2')
            b-form-input#input-2(v-model='form.name', required='', placeholder='Enter name')
          b-form-group#input-group-3(label='Food:', label-for='input-3')
            b-form-select#input-3(v-model='form.food', :options="['pear', 'banana', 'apple']", required='')
              template(slot="first")
                option(:value="null", disabled) Selecciona una opción
          b-form-group#input-group-4
            b-form-checkbox-group#checkboxes-4(v-model='form.checked')
              b-form-checkbox(value='me') Check me out
              b-form-checkbox(value='that') Check that out
          b-button(type='submit', variant='primary', class="mr-2") Submit
          b-button(type='reset', variant='danger') Reset
      b-card
        h5
          span.mr-2 Muestra modales
          b-badge(variant="soft-warning") Nuevo
        p Esto es nuevo
        b-button(v-b-modal.modal-1) Launch demo modal
        b-modal#modal-1(centered, title='BootstrapVue', ok-title="Continuar", cancel-title="Cerrar")
          p.my-4 Hello from modal!
      b-card(no-body)
        template(slot="header")
          .row.align-items-center
            .col
              form.row.align-items-center
                .col-auto.pr-0
                  search-icon.text-help.icon-sm
                .col
                  input.form-control.form-control-flush.search(type='search', placeholder='Search')
            .col-auto
              .dropdown
                b-dropdown#dropdown-right(right='', text='Bulk edit', variant='white', size="sm")
                  b-dropdown-item(href='#') En línea
                  b-dropdown-item(href='#') Backoffice
                  b-dropdown-item(href='#') Desconectado
        b-table.card-table(:items="items", :fields="fields", responsive)
          template(slot="index" slot-scope="data") {{ data.index + 1 }}
</template>

<script>
  export default {
    data () {
      return {
        form: {
          food: null
        },
        items: [
          { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
          { age: 38, first_name: 'Jami', last_name: 'Carney' }
        ],
        fields: [
          {
            key: 'index',
            label: '#'
          },
          'age',
          'first_name',
          'last_name'
        ]
      }
    }
  }
</script>

<style lang="scss">
  .dashboard-container {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .block {
    position: absolute;
    top: 10px;
    left: 10px;
    min-width: 500px;
    border: 1px solid black;
    padding: 2px;

    .gallery {
      min-width: 100%;
      border: 1px solid red;
      padding: 2px;
      white-space: nowrap;
      display: inline-flex;

      .gallery-element {
        flex: 0 0 auto;
        display: inline-block;
        width: 300px;
        height: 100px;
        border: 1px solid green;
      }
    }
  }
</style>
